import { useQuery as o } from "react-query";
import { useBusinessModalContext as s } from "../BusinessModalContext.js";
const r = "me", i = (e) => {
  const {
    apiClient: t
  } = s();
  return o([r], () => t.user.getMe(), e);
};
export {
  r as ME,
  i as useMe
};
